import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_ConsentMstServices = ({
	itemsRef,
	showErrorFor,
}) => {

	return (
		<form id='ACTS_ConsentMstServices' className='file-pdf-document'>
			<div className='file-template'>
				<p className='w-750'><h3>CONSENT FOR MST SERVICES</h3></p>
				
				<p className='w-750'>
					I, <input type="text" id="txtPrintName_1_2" name="txtPrintName_1_2" className='add-only w-350 custom-add-only' /> (print name of individual/legal guardian),
				</p>
				
				<table>
					<tr>
						<td className='w-375'><span className='eleHeader'>Authorize</span></td>
						<td className='w-375'><span className='eleHeader'>To disclose to</span></td>
					</tr>
					<tr>
						<td className='w-375'><input type='text' id='txtAuthorize' name='txtAuthorize' placeholder='Amethyst Consulting & Treatment Solutions, PLLC' className='add-only' /></td>
						<td className='w-375'><input type='text' id='txtToDiscloseTo' name='txtToDiscloseTo' placeholder='MST SERVICES' className='add-only' /></td>
					</tr>
				</table>


				<table>
					<tr>
						<td className='w-750'><span className='eleHeader'>The following information:</span><span className='small'>(check as required)</span></td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbFollowInfo_5_2" name="cbFollowInfo_5_2" className='add-only' value="5" />
							Progress Notes
						</td>
						<td className='w-375'>
							<input type="checkbox" id="cbFollowInfo_6_2" name="cbFollowInfo_6_2" className='add-only' value="6" />
							Treatment/Person-centered Plan
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbFollowInfo_7_2" name="cbFollowInfo_7_2" className='add-only' value="7" />
							Discharge Summary
						</td>
						<td className='w-375'>
							<input type="checkbox" id="cbFollowInfo_8_2" name="cbFollowInfo_8_2" className='add-only' value="8" />
							Education/school records
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbFollowInfo_2_2" name="cbFollowInfo_2_2" className='add-only' value="2" />
							Mental Health Assessment
						</td>
						<td className='w-375'>
							<input type="checkbox" id="cbFollowInfo_4_2" name="cbFollowInfo_4_2" className='add-only' value="4" />
							Physical Examination
						</td>
					</tr>
					<tr>
						<td className='w-750'>
							<input type="checkbox" id="cbFollowInfo_3_2" name="cbFollowInfo_3_2" className='add-only' value="3" />
							Intake and Pre-screening (including psych/medical history)
						</td>
					</tr>
					<tr>
						<td className='w-750'>
							<input type="checkbox" id="cbFollowInfo_1_2" name="cbFollowInfo_1_2" className='add-only' value="1" />
							Presence in treatment (verification of admission/discharge dates)
						</td>
					</tr>
					<tr>
						<td className='w-750'>
							<input type="checkbox" id="cbFollowInfo_9_2" name="cbFollowInfo_9_2" className='add-only' value="9" />
							Other (specify): &nbsp;
							<input type="text" id="txtOtherInfo" name="txtOtherInfo" className='add-only w-350 custom-add-only' />
						</td>
					</tr>
					<tr>
						<td className='w-750'>
							<span className='eleHeader'>For the purpose of</span>
						</td>
					</tr>
					<tr>
						<td className='w-375'>
							<input type="checkbox" id="cbForPurpose_2" name="cbForPurpose_2" className='add-only' value="1" />
							Treatment/Service Planning
						</td>
						<td className='w-375'>
							<input type="checkbox" id="cbForPurpose_1_2" name="cbForPurpose_1_2" className='add-only' value="2" />
							Ongoing treatment
						</td>
					</tr>
					<tr>
						<td className='w-750'>
							<input type="checkbox" id="cbForPurpose_2_2" name="cbForPurpose_2_2" className='add-only' value="3" />
							Insurance/benefit/funding source approval
						</td>
					</tr>
					<tr>
						<td className='w-750'>
							<input type="checkbox" id="cbForPurpose_3_2" name="cbForPurpose_3_2" className='add-only' value="4" />
							Other (specify) : &nbsp;
							<input type="text" id="txtOtherPurpose_2" name="txtOtherPurpose_2" className='add-only w-350 custom-add-only' />
						</td>
					</tr>
				</table>
				<p className='w-750'>
					<span className='small'>
						By signing this release, I am not giving permission for the receiver of this information to re-disclose this information to
						any third party. According to 42 CFR Part 2, information pertaining to Substance Abuse and HIV/Aids (G.S. 30A-143)
						may not be disclosed and is deemed confidential. I understand that my records are protected under state and federal
						confidentiality regulations and cannot be disclosed without written consent unless otherwise provided for in the
						regulations. I understand that I may refuse to sign this consent and that my refusal to sign will not affect my ability to
						obtain treatment. I understand that I may revoke this consent at any time except to the extent that action has been
						taken in reliance on the consent and that in any event this consent expires automatically one year from the date
						below. I understand that this information may be transmitted via facsimile.
					</span>
				</p>
				<table>
					<tr>
						<td className='signature w-500'>
							&nbsp;
						</td>
						<td className='signature w-250'>
							&nbsp;
						</td>
					</tr>
					<tr>
						<td className="small w-500">
							Client/Responsible Party Signature:
						</td>
						<td className="small w-250">
							Date:
						</td>
					</tr>
					<tr>
						<td className='signature w-500'>
							&nbsp;
						</td>
						<td className='signature w-250'>
							&nbsp;
						</td>
					</tr>
					<tr>
						<td className="small w-500">
							Amethyst Representative Signature:
						</td>
						<td className="small w-250">
							Date:
						</td>
					</tr>
				</table>


			</div>
		</form>

	)
}  
